"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = MediaQueryReact;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _MediaQueryCtx = _interopRequireDefault(require("./MediaQueryCtx"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function MediaQueryReact(_ref) {
  var mediaQueries = _ref.mediaQueries,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(_MediaQueryCtx["default"].Provider, {
    value: mediaQueries
  }, children);
}

MediaQueryReact.defaultProps = {
  mediaQueries: {
    mobile: {
      minWidth: 320,
      maxWidth: 480
    },
    mobileLandscape: {
      minWidth: 481,
      maxWidth: 767
    },
    tablet: {
      minWidth: 768,
      maxWidth: 1024
    },
    desktop: {
      minWidth: 1025,
      maxWidth: 2500
    }
  }
};
MediaQueryReact.propTypes = {
  mediaQueries: _propTypes["default"].objectOf(_propTypes["default"].object),
  children: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].string]).isRequired
};